import { render } from "./MobileNotificationBar.vue?vue&type=template&id=0035d778&scoped=true"
import script from "./MobileNotificationBar.vue?vue&type=script&lang=js"
export * from "./MobileNotificationBar.vue?vue&type=script&lang=js"

import "./MobileNotificationBar.vue?vue&type=style&index=0&id=0035d778&lang=scss"
import "./MobileNotificationBar.vue?vue&type=style&index=1&id=0035d778&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0035d778"]])

export default __exports__